<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M36 7H12a2 2 0 00-2 2v30a2 2 0 002 2h24a2 2 0 002-2V9a2 2 0 00-2-2zm-1 31H13V10h22z"/><path d="M17 18h14a1 1 0 000-2H17a1 1 0 000 2zM17 25h8.54a1 1 0 000-2H17a1 1 0 000 2zM31 23h-1.83a1 1 0 000 2H31a1 1 0 000-2zM17 32h8.54a1 1 0 000-2H17a1 1 0 000 2zM31 30h-1.83a1 1 0 000 2H31a1 1 0 000-2z"/></svg>